/*Клеймы для ролевой матрицы  */
export var ClaimEnum;
(function (ClaimEnum) {
    ClaimEnum["CanAll"] = "CanAll";
    ClaimEnum["CanViewMain"] = "CanViewMain";
    ClaimEnum["CanViewStatistic"] = "CanViewStatistic";
    ClaimEnum["CanViewConfiguration"] = "CanViewConfiguration";
})(ClaimEnum || (ClaimEnum = {}));
